import { RestError } from '@azure/core-http';
import { DialogActions, DialogContent } from '@mui/material';
import { Alert, AlertTitle } from '@mui/material';
import { parseErrorMessage } from '../../../../../../core/api/api.context';
import { Dropdown } from '../../../../../../ui/components/pure/dropdown/dropdown.component';
import { TextButton } from '../../../../../../ui/components/pure/text-button/text-button.component';

export interface OpenLockerRequestViewProps {
  error?: RestError;
  hubName?: string;
  lockerContents?: {
    message: string;
  };
  multipleDoors?: {
    doorOptions: { label: string; value: string }[];
    onSelectDoor(doorID: string): void;
  };
  onCancelIntent(): void;
  onSendRequest(): void;
}

export function OpenLockerRequestView(props: OpenLockerRequestViewProps) {
  return (
    <>
      <DialogContent style={{ padding: '16px 24px', fontSize: '14px' }}>
        {props.error && (
          <p>
            <Alert variant="outlined" severity="error">
              <AlertTitle>Something went wrong</AlertTitle>
              {parseErrorMessage(props.error.message)}
            </Alert>
          </p>
        )}
        <p>Is there someone at {props.hubName ?? 'the hub'} to close the door?</p>
        {props.lockerContents ? (
          <p>
            {props.lockerContents.message} — the history of this parcel will record that the locker was opened by you.{' '}
          </p>
        ) : null}

        {props.multipleDoors && props.multipleDoors.doorOptions.length ? (
          <div style={{ width: '100%' }}>
            <Alert variant="standard" severity="info" style={{ marginBottom: '16px' }}>
              Double-sided lockers. Be careful to choose the correct side you'd like to open.
            </Alert>
            <Dropdown
              fullWidth
              textFieldDesktopWidth="100%"
              dropdownVariant="floating"
              menuItems={props.multipleDoors.doorOptions}
              placeholder="Side to open"
              onChange={(e) => props.multipleDoors!.onSelectDoor(e.target.value)}
            />
          </div>
        ) : null}
      </DialogContent>
      <DialogActions style={{ borderTop: '1px solid #EBEDF2', padding: '16px 24px' }}>
        <TextButton color="secondary" variant="outlined" onClick={() => props.onCancelIntent()}>
          Cancel
        </TextButton>
        <TextButton color="danger" variant="outlined" onClick={() => props.onSendRequest()}>
          Open
        </TextButton>
      </DialogActions>
    </>
  );
}
